import React, { Fragment } from "react";
import { Card, CardBody, Col, Input, Label } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { RadioChecked, RadioToggleButtons } from "../../../../Constant";
import { RADIO_TOGGLE, RADIO_TOGGLE_LIST } from "../../../../Data/FormControl/CheckboxAndRadio";

const RadiooggleButtons = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={RadioToggleButtons} span={RADIO_TOGGLE} />
        <CardBody className="common-flex main-radio-toggle">
          <Input className="btn-check radio-light-secondary" id="option1" type="radio" name="options" defaultChecked />
          <Label className="btn list-light-secondary" htmlFor="option1" check>
            {RadioChecked}
          </Label>
          {RADIO_TOGGLE_LIST.map(({ id, text, disabled }, index) => (
            <Fragment key={index}>
              <Input className="btn-check radio-light-secondary" id={id} type="radio" name="options" disabled={disabled} />
              <Label className="btn list-light-secondary" htmlFor={id} check>
                {text}
              </Label>
            </Fragment>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default RadiooggleButtons;
